<template>
  <div class="container3">
    <img
      class="bg"
      prefetch
      src="https://oss.turingsenseai.com/1642581339246032822.png"
      alt=""
    />

    <div v-if="success" class="pic-container1">
      <div class="title">
        <img src="https://oss.turingsenseai.com/1642645997618064391.png" />

        <div class="c">
          {{ data.verifyComment }}
        </div>
      </div>
    </div>

    <div
      class="pic-container"
      :style="{ marginTop: success ? '36px' : '65px' }"
    >
      <div v-if="!success" class="text">
        <img
          class="img"
          src="https://oss.turingsenseai.com/1642645997618064391.png"
        />
      </div>
      <div class="pic-stage" @click="preview">
        <div
          v-if="imgUrl"
          :style="{
            background: `no-repeat center/contain url(${imgUrl})`,
            width: '100%',
          }"
        ></div>
        <div v-if="!imgUrl" class="cover">
          <div class="tip">请上传清晰且类别正确的图片</div>
          <van-uploader :after-read="afterRead" />
          <img
            src="https://oss.turingsenseai.com/1642658039400939606.png"
            alt=""
          />
        </div>
      </div>
    </div>

    <!-- <div class="bbbb" v-if="!success">
      <span class="bb">提交即阅读且同意</span> <a href="https://baoh5.turingsenseai.com/#/static-page/appraisal-notice">《包小鉴AI极速鉴别协议》</a>
    </div> -->

    <div v-if="success" class="btn back gradient" @click="back">返回首页</div>

    <div v-if="!takePhoto" class="btn back gradient">
      <van-uploader :after-read="afterRead" />
      <span>上传图片</span>
    </div>

    <div v-if="takePhoto && !success" class="btn back gradient" @click="submit">
      <span>立即鉴定</span>
    </div>

    <div v-if="takePhoto && !success" class="btn back">
      <van-uploader :after-read="afterRead" />
      <span>重新上传</span>
    </div>

    <van-overlay :show="show">
      <div class="scan-wrapper">
        <div class="qr-scanner">
          <div class="box">
            <div class="line"></div>
            <div class="angle"></div>
          </div>
        </div>
        <div class="img">
          <img :src="imgUrl" alt="" />
        </div>
      </div>
    </van-overlay>

    <vue-canvas-poster
      :widthPixels="0"
      :painting="painting"
      @success="successPainting"
      @fail="fail"
    ></vue-canvas-poster>
  </div>
</template>
<script>
// https://oss.turingsenseai.com/1642666019819575341.png
//https://oss.turingsenseai.com/1642666038510779975.png
import { Toast, ImagePreview } from "vant";
import { uploadImage } from "../../common/api/common";
import axios from "axios";
import { psVerify } from "@/common/api/ps";

Toast.setDefaultOptions({ duration: 2000 });
export default {
  components: {
    [ImagePreview.Component.name]: ImagePreview.Component,
  },
  data() {
    return {
      takePhoto: false,
      success: false,
      loading: false,
      imgUrl: null,
      show: false,
      data: {},
      painting: null,
      // painting: {
      //   background: "https://oss.turingsenseai.com/baogo1643250527090506988.png",
      //   width: '1080px',
      //   height: '1440px',
      //   views: [
      //     {
      //       type: "rect",
      //       css: {
      //         width: '200px',
      //         height: '30px',
      //         top: "905px",
      //         left: "330px",
      //         color: 'radial-gradient(#FF3535C0 0%, rgba(204, 255, 109, 0.76) 100%)'
      //       },
      //     }
      //   ],
      // },
    };
  },
  methods: {
    uploadAgain() {
      this.takePhoto = false;
      this.imgUrl = null;
    },
    async afterRead(file) {
      if (file && file.file.size > 10 * 1024 * 1024) {
        Toast("图片大小不能超过10M");
        return;
      }
      const instance = Toast.loading({
        message: "上传中...",
        forbidClick: true,
        onOpened: async () => {
          const res = await uploadImage({
            imgB64: file.content.split(",")[1],
          }).catch(() => {
            instance.clear();
            return {};
          });

          if (res.errorMsg === "Success") {
            this.imgUrl = res.imageUrl;
            this.load(res.imageUrl).then(() => {
              this.takePhoto = true;
              instance.clear();
            });
          }
        },
      });
    },
    preview() {
      if (this.imgUrl) {
        ImagePreview({
          images: [this.imgUrl],
          closeable: true,
        });
      }
    },
    async fail() {},
    async successPainting(src) {
      this.imgUrl = src;
    },
    async submit(e) {
      if (!this.$route.query) {
        return;
      }

      let { type, category } = this.$route.query;

      let verifyCategory = parseInt(category);
      let verifyType = parseInt(type);
      let verifyCategoryName;
      let verifyTypeName;

      this.show = true;

      // if (verifyCategory === 1) {
      //   verifyCategoryName = "证件";
      // }

      // if (verifyCategory === 2) {
      //   verifyCategoryName = "执照";
      // }

      // if (verifyCategory === 3) {
      //   verifyCategoryName = "门头照";
      // }

      // if (verifyCategory === 4) {
      //   verifyCategoryName = "特殊资质";
      // }

      // if (verifyType === 1) {
      //   verifyTypeName = "身份证";
      // }

      // if (verifyType === 2) {
      //   verifyTypeName = "营业执照";
      // }

      // if (verifyType === 3) {
      //   verifyTypeName = "门头照";
      // }

      // if (verifyType === 4) {
      //   verifyTypeName = "特殊资质";
      // }

      setTimeout(() => {
        psVerify({
          verifyParam: {
            oriImgUrl: this.imgUrl,
            verifyCategory,
            verifyType,
            // verifyCategoryName,
            // verifyTypeName,
            verifySource: "图灵鉴定",
          },
        }).then(async (res) => {
          if (res.errorMsg === "Success") {
            this.data = res.psVerifyRecord;
            // this.imgUrl = res.psVerifyRecord.oriImgUrl
            this.success = true;
            document.title = "防篡改鉴别结论";

            if (res.psVerifyRecord.suspectAreas) {
              try {
                const suspectAreas = JSON.parse(
                  res.psVerifyRecord.suspectAreas
                );
                this.painting = {
                  background: res.psVerifyRecord.oriImgUrl,
                  width: res.psVerifyRecord.width + "px",
                  height: res.psVerifyRecord.height + "px",
                  views: suspectAreas.map((v) => {
                    return {
                      type: "rect",
                      css: {
                        width: v[2] + "px",
                        height: v[3] + "px",
                        top: v[1] + "px",
                        left: v[0] + "px",
                        color:
                          "radial-gradient( #5CFAFFD2 0%, #35F8FFB7 30.73%, rgba(97, 198, 255, 0.685714) 65.1%, rgba(100, 186, 255, 0.55579) 75.52%, rgba(105, 159, 255, 0.274286) 84.9%, rgba(109, 150, 255, 0) 100%)",
                      },
                    };
                  }),
                };
              } catch (error) {}
            }

            this.show = false;
          } else {
            this.show = false;
            if (res.errorMsg) {
              Toast({
                message: res.errorMsg,
                duration: 3000,
              });
            }
          }
        });
      }, 3000);
    },
    load(src) {
      return new Promise((resolve, reject) => {
        const image = new Image();
        image.addEventListener("load", resolve);
        image.addEventListener("error", reject);
        image.src = src;
      });
    },
    back() {
      this.$router.replace("/appraisal/ps");
      // this.takePhoto = false
      // this.success = false;
      // this.imgUrl = null
      // document.title = "上传图片"
    },
  },
};
</script>

<style lang="scss">
.container3 {
  height: 100vh;
  position: absolute;
  left: 0;
  right: 0;
  // width: 100vw;

  .bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    z-index: -2;
  }

  .btn-wrapper > div {
    display: flex;
    justify-content: center;
    margin-top: 100px;
  }

  .btn {
    width: 614px;
    height: 96px;
    border-radius: 200px;
    background: #efeff4;
    color: #3a3d44;
    text-align: center;
    line-height: 96px;
    font-weight: 500;
    font-size: 34px;
  }

  .back {
    margin: 0 auto;
    margin-top: 52px;
  }

  .bbbb {
    text-align: center;
    font-size: 24px;
    .bb {
      color: #828393;
    }
  }

  .pic-container {
    height: 618px;
    width: 618px;
    position: relative;
    margin: 130px auto 200px auto;
    .pic-stage {
      height: 618px;
      width: 618px;
      border-radius: 66px;
      display: flex;
      justify-content: center;
      overflow: hidden;
      z-index: 20;
      background: linear-gradient(
        190.61deg,
        rgba(255, 255, 255, 0.52) 19.29%,
        rgba(248, 248, 255, 0.8) 54.41%,
        rgba(255, 255, 255, 0.77) 90.02%
      );
      box-shadow: -8.22948px 39.9926px 115.213px rgba(58, 148, 255, 0.11);
      backdrop-filter: blur(15.636px);
      .cover {
        display: flex;
        justify-content: space-around;
        flex-direction: column;
        position: relative;

        .van-uploader {
          left: 0;
          height: 100%;
          .van-uploader__wrapper {
            height: 100%;
            .van-uploader__upload {
              height: 100%;
            }
          }
        }
        .tip {
          text-align: center;
          color: #3a3d44;
          font-size: 28px;
          font-weight: 300;
        }
        img {
          width: 456px;
          background: rgba(163, 205, 255, 0.02);
          box-shadow: inset 0px 0px 100px rgba(50, 135, 255, 0.11);
          // box-shadow: 0px 0px 100px rgba(50, 135, 255, 0.11);
          border-radius: 5px;
          // position: absolute;
          // position: relative;
          // bottom: 86px;
        }
      }
    }
    .text {
      position: absolute;
      opacity: 0.5;
      top: -70px;
      left: 50px;
      z-index: -1;
      img {
        width: 160px;
      }
    }
  }

  .pic-container1 {
    margin-top: 100px;
    // margin-left: 120px;
    .title {
      display: flex;
      justify-content: center;
      align-items: center;
      // justify-content: center;
      img {
        opacity: 0.5;
        width: 160px;
        position: absolute;
        left: 120px;
      }
      .c {
        color: #3a3d44;
        font-size: 28px;
        font-weight: 400;
        text-align: center;
        margin: 0 120px;
        z-index: 100;
      }
    }
  }

  .gradient {
    background: linear-gradient(270deg, #3a94ff 0%, #74c8f5 100%);
    font-style: normal;
    color: #fff;
    background: linear-gradient(270deg, #3a94ff 6.84%, #74c8f5 93.49%);
    box-shadow: 0px 2px 60px rgba(23, 137, 255, 0.2);
    position: relative;
  }

  .van-overlay {
    background: rgba(0, 0, 0, 0.8);
  }

  .van-uploader {
    position: absolute;
    width: 100%;
    left: 100px;

    .van-uploader__wrapper {
      width: 100%;
      .van-uploader__upload {
        width: 100%;
        .van-icon-photograph::before {
          content: "";
        }
        margin: unset;
        height: 96px;
        width: 614px;
        opacity: 0;
      }
    }
  }

  .scan-wrapper {
    .qr-scanner {
      position: absolute;
      top: 0;
      z-index: 100;
      background: rgba(255, 255, 255, 0);
      background-image: linear-gradient(#0ba8fc1e 1px, transparent 0),
        linear-gradient(90deg, #0ba8fc1e 1px, transparent 0);
      background-size: 25px 25px;
      width: 100%;
      height: 100%;
      animation: scanner-bg 3s infinite;
    }

    .qr-scanner .box {
      width: 85vw;
      height: 100vh;
      max-height: 85vh;
      max-width: 85vh;
      position: relative;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      overflow: hidden;
    }

    .qr-scanner .line {
      // height: calc(100% - 2px);
      height: 200px;
      width: 100%;
      background: linear-gradient(180deg, #3a93ff00 43%, #1fb0ffd0 211%);
      border-bottom: 10px solid #0073ffd0;
      transform: translateY(-100%);
      animation: radar-beam 3s infinite;
      animation-timing-function: cubic-bezier(0.53, 0, 0.43, 0.99);
    }

    .qr-scanner .box:after,
    .qr-scanner .box:before {
      top: 0;
      border-top-color: #00ff33;
    }

    .qr-scanner .angle:after,
    .qr-scanner .angle:before {
      bottom: 0;
      border-bottom-color: #00ff33;
    }

    .qr-scanner .box:before,
    .qr-scanner .angle:before {
      left: 0;
      border-left-color: #00ff33;
    }

    .qr-scanner .box:after,
    .qr-scanner .angle:after {
      right: 0;
      border-right-color: #00ff33;
    }

    @keyframes radar-beam {
      0% {
        transform: translateY(-100%);
        opacity: 1;
      }

      100% {
        transform: translateY(100vh);
        opacity: 0.3;
      }
    }

    @keyframes scanner-bg {
      0% {
        opacity: 0;
      }

      70% {
        opacity: 1;
      }

      100% {
        opacity: 0;
      }
    }

    .img {
      width: 100vw;
      height: 100vh;
      display: flex;
      align-items: center;
      justify-content: center;
      // background-image: url('https://scpic.chinaz.net/files/pic/pic9/202201/apic37929.jpg');
      // background-size: contain;
      // background-repeat: no-repeat;
      // background-position: center;
    }
  }
}
</style>
